export class PagePaths {
  private constructor() {}
  private static appRoot = "/manager";

  static Account = {
    accounts: PagePaths.buildPath(PagePaths.appRoot, "accounts"),
    personal: PagePaths.buildPath(PagePaths.appRoot, "accounts", "personal"),
  };

  static Order = {
    orders: PagePaths.buildPath(PagePaths.appRoot, "orders"),
    ordersDetail: PagePaths.buildPath(PagePaths.appRoot, "orders", "detail"),
  };

  static Masters = {
    masters: PagePaths.buildPath(PagePaths.appRoot, "masters"),
  };

  static internal = PagePaths.buildPath(PagePaths.appRoot, "internal");

  static settlements: string = PagePaths.buildPath(
    PagePaths.appRoot,
    "settlements",
  );

  static billings: string = PagePaths.buildPath(PagePaths.appRoot, "billings");

  // FIXME: 商用リリース前に環境変数依存に変更して、ci/cdで設定するように修正
  static Other = {
    news: "https://helpdesk.sride.jp/hc/ja/articles/33472935682967",
    helpdesk:
      "https://helpdesk.sride.jp/hc/ja/requests/new?ticket_form_id=33144135861911",
  } as const;

  // FIXME: redirect/managerはこっちかもしれない

  static abs = (relPath: string): string =>
    `${process.env.NEXT_PUBLIC_BASE_URL}${relPath}`;

  private static buildPath(
    base: string,
    ...paths: (string | number)[]
  ): string {
    return [base, ...paths].join("/");
  }
}
